import { IconButton, Tooltip } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { useHomesite } from "../../../../components/core/homesites/homesiteColumns";
import { useSnackbarContext } from "../../../../components/globalSnackNotify/globalSnackNotifyContext";

interface BuyerListingActionsProps {
  params: any;
}

export const BuyerListingActions: React.FC<BuyerListingActionsProps> = (
  params: any
) => {
  const { showSnackbar } = useSnackbarContext();

  const { handleEdit } = useHomesite();
  const phone = params.row?.displayVals?.phone || "";
  const email = params.row?.displayVals?.email || "";
  
  return (
    <div
      style={{
        display: "flex",
        alignItems: "left",
        justifyContent: "left",
        padding: "4px",
      }}
    >
      <Tooltip title={email ? email : "Unavailable"} arrow>
        <IconButton
          size="small"
          sx={{
            padding: "4px",
            "&:hover": {
              backgroundColor: "rgba(0, 93, 170, 0.1)",
            },
          }}
          onClick={() => {
            handleEdit(params);
            navigator.clipboard.writeText(email);
            if (email) {
              showSnackbar("Email(s) Copied to Clipboard!", "success");
            } else {
              showSnackbar("Email(s) Unavailable", "info");
            }
          }}
        >
          <EmailIcon style={{ color: "#005DAA", fontSize: "20px" }} />
        </IconButton>
      </Tooltip>
      <Tooltip title={phone ? phone : "Unavailable"} arrow>
        <IconButton
          size="small"
          sx={{
            padding: "4px",
            "&:hover": {
              backgroundColor: "rgba(0, 93, 170, 0.1)",
            },
          }}
          onClick={() => {
            handleEdit(params);
            navigator.clipboard.writeText(phone);
            if (phone) {
              showSnackbar("Phone Number(s) Copied to Clipboard!", "success");
            } else {
              showSnackbar("Phone Number(s) Unavailable", "info");
            }
          }}
        >
          <PhoneIcon style={{ color: "#005DAA", fontSize: "20px" }} />
        </IconButton>
      </Tooltip>
    </div>
  );
};
